import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get, post} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
    success: '',
    formLoading: false
}

export const fetchDepartment = createAsyncThunk("fetchDoctors", (params, {dispatch}) => {
    return get(params);
});

export const postForm = createAsyncThunk("careerForm", (params) => {
    return post(params);
});


const postSlice = createSlice({
    name: 'appoint',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchDepartment.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchDepartment.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''

        })
        builder.addCase(fetchDepartment.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
        builder.addCase(postForm.pending, (state) => {
            state.formLoading = true;
            state.success = [];
            state.error = "";
        });
        builder.addCase(postForm.fulfilled, (state, action) => {
            state.formLoading = false;
            state.success = action.payload.message;
            state.error = "";
            console.log('payload.message',state.success)

        });
        builder.addCase(postForm.rejected, (state, action) => {
            state.formLoading = false;
            state.success = '';
            state.error = action.error;

        })

    }
})


export default postSlice.reducer
